export default __webpack_public_path__ + "static/media/15.d4cf0a54.png";